"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NomosEvaluationJobStatus = exports.PrometheusLoggingIdentityKey = exports.PrometheusMetadataHeader = exports.DEFAULT_QUESTION_METADATA_LOAN_APPLICATION_TYPE = exports.DEFAULT_QUESTION_METADATA_ACCOUNT_STATE = exports.AccountState = exports.NomosAdType = exports.NomosProductType = exports.QuestionMedium = exports.AnswerBlockedStage = void 0;
const loanApplication_1 = require("../origination/loanApplication");
// Stage at which the answer is blocked
/** @TranslateToPython */
var AnswerBlockedStage;
(function (AnswerBlockedStage) {
    AnswerBlockedStage["MESSAGE_ENQUEUE"] = "MESSAGE_ENQUEUE";
    AnswerBlockedStage["PRE_ANSWER_CLASSIFICATION"] = "PRE_ANSWER_CLASSIFICATION";
    AnswerBlockedStage["POST_ANSWER_GUARDRAILS"] = "POST_ANSWER_GUARDRAILS";
    AnswerBlockedStage["AUTO_POSTING_GUARDRAILS"] = "AUTO_POSTING_GUARDRAILS";
    AnswerBlockedStage["ANSWER_GENERATION_FAILURE"] = "ANSWER_GENERATION_FAILURE";
})(AnswerBlockedStage || (exports.AnswerBlockedStage = AnswerBlockedStage = {}));
/** @TranslateToPython */
var QuestionMedium;
(function (QuestionMedium) {
    QuestionMedium["sms"] = "sms";
    QuestionMedium["email"] = "email";
    QuestionMedium["feedbackBox"] = "feedbackBox";
    QuestionMedium["chat"] = "chat";
    QuestionMedium["call"] = "call";
    QuestionMedium["heloc_ad"] = "heloc_ad";
    QuestionMedium["direct_mail_ad"] = "direct_mail_ad";
})(QuestionMedium || (exports.QuestionMedium = QuestionMedium = {}));
/** @TranslateToPython */
var NomosProductType;
(function (NomosProductType) {
    NomosProductType["heloc"] = "heloc";
    NomosProductType["flex"] = "flex";
    NomosProductType["rewards"] = "rewards";
})(NomosProductType || (exports.NomosProductType = NomosProductType = {}));
/** @TranslateToPython */
var NomosAdType;
(function (NomosAdType) {
    NomosAdType["digital"] = "digital";
    NomosAdType["script"] = "script";
    NomosAdType["direct_mail"] = "direct_mail";
    NomosAdType["ad_performance"] = "ad_performance";
    NomosAdType["landing_page"] = "landing_page";
    NomosAdType["direct_mail_ad_performance"] = "direct_mail_ad_performance";
})(NomosAdType || (exports.NomosAdType = NomosAdType = {}));
/** @TranslateToPython*/
var AccountState;
(function (AccountState) {
    AccountState["applicant"] = "applicant";
    AccountState["current"] = "current";
    AccountState["dq"] = "dq";
    AccountState["unknown"] = "unknown";
    AccountState["lead"] = "lead";
})(AccountState || (exports.AccountState = AccountState = {}));
/** @TranslateToPython */
exports.DEFAULT_QUESTION_METADATA_ACCOUNT_STATE = AccountState.unknown;
/** @TranslateToPython */
exports.DEFAULT_QUESTION_METADATA_LOAN_APPLICATION_TYPE = loanApplication_1.LoanApplicationType.AVEN_ORIGINATION;
// HTTP header names for propagating metadata from aven_backend to ai_agent
/** @TranslateToPython */
var PrometheusMetadataHeader;
(function (PrometheusMetadataHeader) {
    PrometheusMetadataHeader["ZENDESK_TICKET_ID"] = "x-zendesk-ticket-id";
    PrometheusMetadataHeader["LOAN_APPLICATION_ID"] = "x-loan-application-id";
    PrometheusMetadataHeader["APPLICANT_ID"] = "x-applicant-id";
})(PrometheusMetadataHeader || (exports.PrometheusMetadataHeader = PrometheusMetadataHeader = {}));
// Mapping from header names to logging identity keys used in Python
/** @TranslateToPython */
var PrometheusLoggingIdentityKey;
(function (PrometheusLoggingIdentityKey) {
    PrometheusLoggingIdentityKey["ZENDESK_TICKET_ID"] = "zendeskTicketId";
    PrometheusLoggingIdentityKey["LOAN_APPLICATION_ID"] = "loanApplicationId";
    PrometheusLoggingIdentityKey["APPLICANT_ID"] = "applicantId";
    PrometheusLoggingIdentityKey["NOMOS_JOB_ID"] = "nomosJobId";
    PrometheusLoggingIdentityKey["NOMOS_ENDPOINT"] = "nomosEndpoint";
    PrometheusLoggingIdentityKey["NOMOS_EVALUATION_SOURCE"] = "nomosEvaluationSource";
    PrometheusLoggingIdentityKey["NOMOS_AGENT_NAME"] = "nomosAgentName";
})(PrometheusLoggingIdentityKey || (exports.PrometheusLoggingIdentityKey = PrometheusLoggingIdentityKey = {}));
// Status for Nomos evaluation jobs
/** @TranslateToPython */
var NomosEvaluationJobStatus;
(function (NomosEvaluationJobStatus) {
    NomosEvaluationJobStatus["PROCESSING"] = "processing";
    NomosEvaluationJobStatus["COMPLETED"] = "completed";
    NomosEvaluationJobStatus["FAILED"] = "failed";
})(NomosEvaluationJobStatus || (exports.NomosEvaluationJobStatus = NomosEvaluationJobStatus = {}));
